/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';
import type { SiegeSocialSelectorGridDto } from './SiegeSocialSelectorGridDto';
import {
    SiegeSocialSelectorGridDtoFromJSON,
    SiegeSocialSelectorGridDtoFromJSONTyped,
    SiegeSocialSelectorGridDtoToJSON,
} from './SiegeSocialSelectorGridDto';

/**
 * 
 * @export
 * @interface SiegeSocialSelectorGridDtoPaginatedResults
 */
export interface SiegeSocialSelectorGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof SiegeSocialSelectorGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<SiegeSocialSelectorGridDto>}
     * @memberof SiegeSocialSelectorGridDtoPaginatedResults
     */
    results?: Array<SiegeSocialSelectorGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof SiegeSocialSelectorGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the SiegeSocialSelectorGridDtoPaginatedResults interface.
 */
export function instanceOfSiegeSocialSelectorGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SiegeSocialSelectorGridDtoPaginatedResultsFromJSON(json: any): SiegeSocialSelectorGridDtoPaginatedResults {
    return SiegeSocialSelectorGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function SiegeSocialSelectorGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): SiegeSocialSelectorGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(SiegeSocialSelectorGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function SiegeSocialSelectorGridDtoPaginatedResultsToJSON(value?: SiegeSocialSelectorGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(SiegeSocialSelectorGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

